import React, { useEffect } from "react";
import { Layout, Card, Button, Table } from "antd";
import {
  PlusOutlined,
  CheckOutlined,
  PauseOutlined,
  CloseOutlined,
  SearchOutlined,
  AreaChartOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { getServerList, changeStatus } from "../../services/server";
import { toast } from "react-toastify";
import languages from "../../constants/languages";
import ListNotifications from "./ListNotifications";

export const Home = (props) => {
  const [data, setData] = React.useState([]);
  const [loadingButtons, setLoadingButtons] = React.useState([]);

  useEffect(() => {
    getServerList().then((res) => {
      setData(res.data);
    });
  }, []);

  const onClickCreate = () => {
    props.history.push(`${process.env.PUBLIC_URL}/server/create`);
  };

  const onClickCell = (record) => {
    props.history.push(`${process.env.PUBLIC_URL}/server/status/${record._id}`);
  };

  const onEditServer = (record) => {
    props.history.push(`${process.env.PUBLIC_URL}/server/detail/${record._id}`);
  };

  const onTogglePause = (record) => {
    setLoadingButtons([...loadingButtons, record._id]);
    changeStatus(
      record._id,
      record.status === "pause" ? "checking" : "pause"
    ).then((res) => {
      if (res.status === 1) {
        toast.success(
          record.status === "pause"
            ? "サーバの監視が再開されました。"
            : "サーバーの監視が一時停止されました。"
        );
        const nData = data.map((item) =>
          item._id === record._id ? res.data : item
        );
        setData(nData);
        // remove loading button
        // let index = loadingButtons.indexOf(record._id);
        // loadingButtons.splice(index, 1);
        setLoadingButtons(
          loadingButtons.filter((item) => item._id != record._id)
        );
      } else {
        toast.error(res.message);
      }
    });
  };

  const columns = [
    {
      title: "監視設定名／サーバアドレス",
      dataIndex: "name",
      key: "name",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 3,
      },
      width: "30%",
      showSorterTooltip: false,
      render: (name, row) => (
        <a onClick={() => onClickCell(row)}>
          <AreaChartOutlined className="icon-chart" />
          {name}
        </a>
      ),
    },
    {
      title: "状態",
      dataIndex: "status",
      key: "status",
      width: "15%",
      render: (status) =>
        status === "working" ? (
          <CheckOutlined className="success-icon" />
        ) : status === "pause" ? (
          <PauseOutlined className="pause-icon" />
        ) : status === "checking" ? (
          <LoadingOutlined className="checking-icon" />
        ) : (
          <CloseOutlined className="error-icon" />
        ),
    },
    {
      title: "監視間隔",
      dataIndex: "repeat_time",
      key: "repeat_time",
      render: (repeat_time, row) => (
        <>
          <SearchOutlined /> {repeat_time}分{row.web_ping && <div>Ping</div>}
          {row.web_https && <div>TCP443 (HTTPS Web)</div>}
          {row.smtp && <div>TCP25 (SMTP)</div>}
          {row.pop && <div>TCP110 (POP)</div>}
          {row.imap && <div>TCP143 (IMAP)</div>}
          {row.smtp_submitsion_port && (
            <div>TCP587 (SMTP Submitssion port)</div>
          )}
          {row.ftp && <div>TCP21 (FTP)</div>}
        </>
      ),
    },
    {
      title: "再通知間隔",
      dataIndex: "repeat_time_notification",
      key: "repeat_time_notification",
      render: (time) => time + "分",
    },
    {
      title: "",
      key: "action",
      render: (text, record) => (
        <>
          <Button
            type="primary"
            className="tbl-btn"
            onClick={() => onTogglePause(record)}
            loading={loadingButtons.includes(record._id)}
          >
            {record.status === "pause" ? "再開" : "停止"}
          </Button>
          <Button
            type="primary"
            className="tbl-btn"
            onClick={() => onEditServer(record)}
          >
            変更
          </Button>
        </>
      ),
    },
  ];

  return (
    <Layout className="layout-server">
      <Card title="監視サーバー" className="flex-1">
        <div className="row">
          <div className="total-servers">{`監視されているサーバ数: ${data.length}`}</div>
          <Button
            icon={<PlusOutlined />}
            className="btn-success"
            type="primary"
            onClick={onClickCreate}
          >
            監視サーバーを追加
          </Button>
        </div>
        <Table
          dataSource={data}
          columns={columns}
          bordered={true}
          rowKey={"_id"}
          onCell={onClickCell}
        />
        <ListNotifications onClickServer={onClickCell} />
      </Card>
    </Layout>
  );
};
